module.exports = __webpack_public_path__ + "static/media/maxresdefault.07bd3b11.png";